import { Channel } from "../enums/channel";
import { PracticeFeature } from "../enums/practice-feature";
import { Practice } from "../models/Practice";
import { practiceHasFeature } from "./practice-has-feature";

interface ChannelOption {
    name: Channel;
    code: Channel;
    className: string;
    icon: string;
    inactive: boolean;
}

export function getPermittedMessagingChannels(practice: Practice, forBroadcast: boolean = false): ChannelOption[] {
    let defaultChannels: ChannelOption[] = [];
    let channelCode: Channel = Channel.WHATSAPP;
    const smsMessaging = practiceHasFeature(practice, PracticeFeature.SMS_MESSAGING);
    const whatsappMessaging = practiceHasFeature(practice, PracticeFeature.WHATSAPP_MESSAGING);
    const whatsappForBroadcast = practiceHasFeature(practice, PracticeFeature.WHATSAPP_BROADCASTS);
    const practiceWhatsappChannel = practice.whatsapp_channel;
    if (
        practiceWhatsappChannel === Channel.WHATSAPP360 ||
        practiceWhatsappChannel === Channel.WHATSAPP360CLOUD
    ) {
        channelCode = practiceWhatsappChannel
    }

    if (smsMessaging) {
        defaultChannels.push(
            {
                name: Channel.SMS,
                code: Channel.SMS,
                className: Channel.SMS.toLowerCase(),
                icon: 'SMS.svg',
                inactive: !smsMessaging,
            }
        );
    }
    if (whatsappMessaging && !forBroadcast) {
        defaultChannels.push({
            name: Channel.WHATSAPP,
            code: Channel.WHATSAPP,
            className: Channel.WHATSAPP.toLowerCase(),
            icon: 'WhatsApp.svg',
            inactive: !whatsappMessaging,
        });
    }

    if (whatsappForBroadcast && forBroadcast) {
        defaultChannels.push({
            name: Channel.WHATSAPP,
            code: channelCode,
            className: Channel.WHATSAPP.toLowerCase(),
            icon: 'WhatsApp.svg',
            inactive: !whatsappForBroadcast,
        });
    }

    return defaultChannels;
}
